export default __webpack_public_path__ + "static/portfolio-img-4-db0c527c071f41f8043ee94dcaab37db.png";